import { useAuth } from "@/state/auth";

export function useGlobalServices(): void {
  useAuth();
}
